/** Private composer projection, not a chat message or a delivery retry command. */
export interface ScheduledMessageStatus {
  id: number;
  content: string;
  status: string;
  createdAt: string;
  scheduledFor: string;
  /** The worker records this for both sent and failed outcomes. */
  completedAt: string | null;
}

/** The composer is an outstanding-delivery indicator, not a sent-history count.
 * Never infer success from elapsed time: overdue or unknown states need attention.
 */
export function outstandingScheduledMessages(messages: ScheduledMessageStatus[]): ScheduledMessageStatus[] {
  return messages.filter(message => message.status !== 'sent');
}
